export default __webpack_public_path__ + "static/media/daily-food-tracker.2d9fcde3.png";